import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
//import axios from 'axios';
import ForgotPassword from './ForgotPassword'; 
//import { useData } from '../contexts/DataContext'; 

import { useAppData } from "../hooks/useAppData";
import { useAppStore } from "../hooks/useAppStore";
import { useUserData } from "../hooks/useUserData";
import { useUserStore } from "../hooks/useUserStore";

import { useTranslation, Trans } from 'react-i18next'; 
import { useNotification } from '../contexts/NotificationContext'; 
import TurnstileWidget from '../components/Widget/TurnstileWidget';

import Footer from '../components/Layout/Footer';
//import PrivacyPolicy from './PrivacyPolicy';

import LogRocket from 'logrocket';
import * as Sentry from '@sentry/react';

// Importing assets
import BwossyLogo from "../components/Layout/BwossyLogo"; 

import logo from '../assets/images/bwossy-logo.svg';

import {
  ErrorOutline as ErrorOutlineIcon,
  ErrorOutlineSharp,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material';

import { 
  IconButton, 
  InputAdornment, 
  TextField, 
  Button 
} from '@mui/material';

const Homepage = () => {
  const { t } = useTranslation(); // Hook to access translation
  const { showNotification } = useNotification();

  const [isLogoPressed, setIsLogoPressed] = useState(false);

  const [loading, setLoading] = useState(false);
  const [turnstileTokenStatus, setTurnstileTokenStatus] = useState(''); // Track Turnstile status

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  /*const { setWordListId, setSoundboardId } = useData();*/

const { 
    wordList, 
    isWordListPending,
    isWordListError, 
    wordListRefetch,
    updateWordList,
    updateWordListOnReorder,
    addGroup,
    deleteGroup,
    addWordItem,
    deleteWord,
    soundboard,
    shapes,
    isSoundboardPending,
    isSoundboardError, 
    soundboardRefetch,
    addShape,
    updateShape,
    updateButton,
    unassignButton,
    deleteShape,
    handleOptionChange,
    handleAssignedWordTooltipVisibility,
    assignedWordTooltipVisibility
  } = useAppData();
    
    const { 
      wordListId, setWordListId, 
      soundboardId, setSoundboardId,
      stageWidth, setStageWidth,
      stageHeight, setStageHeight,
      buttonPopovers, setButtonPopovers,
      shapePopovers, setShapePopovers,
      selectedItem, setSelectedItem,
      wordListWidth, setWordListWidth
  } = useAppStore();

  const { loginUser } = useUserData();


  const [isForgotPasswordOverlayVisible, setForgotPasswordOverlayVisible] = useState(false);
  const handleOpenForgotPasswordOverlay = () => setForgotPasswordOverlayVisible(true);
  const handleCloseForgotPasswordOverlay = () => setForgotPasswordOverlayVisible(false);

  const [isPolicyOverlayVisible, setPolicyOverlayVisible] = useState(false);
  const [policyOverlayContent, setPolicyOverlayContent] = useState({ title: '', content: '' });

  
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleOpenPolicyOverlay = (title, content) => {
    setPolicyOverlayContent({ title, content });
    setPolicyOverlayVisible(true);
  };
  const handleClosePolicyOverlay = () => setPolicyOverlayVisible(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true); // Set loading state to true
    setSubmitError(''); // Clear any previous server errors

    if (!email || !password) {
      if (!email) setEmailError(t('errors.emailRequired'));
      if (!password) setPasswordError(t('errors.passwordRequired'));
      setLoading(false); // Re-enable the button after validation
      return;
    }

    if (emailError || passwordError) {
      setLoading(false); // Re-enable the button if there are client-side errors
      return;
    }

    loginUser.mutate(
      { email, password },
      {
        onSuccess: (data) => {
          const user = data?.user;
          if (user?.setupProgress) {
            navigate('/setup-wizard/0');
          } else {
            navigate('/MainContent');
          }
        },
        onError: (error) => {
          if (error?.response?.status === 404) {
            setSubmitError(
              <Trans
                i18nKey="errors.emailNotRegistered"
                components={{
                  1: <Link to={`/register?email=${encodeURIComponent(email)}`} className="register-link">register for a new account</Link>,
                }}
              />
            );
          } else if (error?.response?.status === 401) {
            setSubmitError(t('errors.credentialsFailed'));
          } else {
            setSubmitError(t('errors.loginFailed'));
          }
        },
        onSettled: () => setLoading(false),
      }
    );
    /*try {
      const response = await axios.post(`${baseURL}/api/users/login`, { email, password });
      if(response && response.data && response.data.accessToken) {
        const { user, accessToken, wordListId, soundboardId } = response.data;

        if (!user.isVerified) {
          navigate(`/verify-email?email=${encodeURIComponent(user.email)}`);
          return;
        }

        localStorage.setItem('userToken', accessToken);
        setWordListId(wordListId);
        setSoundboardId(soundboardId);

        let consentTracking = false;
        if (window.klaro && typeof window.klaro.getManager === "function") {
          const manager = window.klaro.getManager();
          consentTracking = manager.getConsent("brevo") || false;
        }

        if (consentTracking) {
          LogRocket.identify(user.id, {
            email: user.email,
            loginMethod: 'Form', 
          });

          Sentry.setUser({
            id: user.id,
            email: user.email,
          });
        }
          
        navigate('/MainContent');
      } else {
        setSubmitError(t('errors.credentialsFailed'));
      }
    } catch ( error ) {
      const extra = { 
        message: 'login failed',
        email,
        password
      };
      
      if (error.response && error.response.status === 404) {
        setSubmitError(
          <>
          <Trans i18nKey="errors.emailNotRegistered"
            components={{
              1: <Link to={`/register?email=${encodeURIComponent(email)}`} className="register-link">register for a new account</Link>,
            }}
          />
          </>
        );
      } else if (error.response && error.response.status === 401) {
        setSubmitError(t('errors.credentialsFailed'));
      } else {
        setSubmitError(t('errors.loginFailed'));
      }
      setEmailError(''); // Clear specific errors if any
      setPasswordError('');
      setEmail(email); // Reset email to trigger re-validation
      setPassword(password); // Reset password to trigger re-validation
    } finally {
      setLoading(false);
    }*/
  };


  useEffect(() => {
    const timer = setTimeout(() => {
      if (email && !validateEmail(email)) {
        setEmailError(t('errors.invalidEmail'));
      } else {
        setEmailError('');
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [email]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsLogoPressed(true);
      setTimeout(() => {
        setIsLogoPressed(false);
      }, 500); // Wait for the animation to complete (0.5 seconds)
    }, 600000); // Wait for 10 minutes before running the animation again

    return () => clearInterval(intervalId);
  }, []);

  
  return (
    <div className="hero-section homepage">
      
      <div className='homepage-nav-container'>
          <div className="login-logo-container">
            <a href="./">
              <span className="login-logo-name">
                <Trans i18nKey="common.appNameLogo" components={[<BwossyLogo />]} />
              </span>
              {/*<BwossyLogo />*/}
              {/*<img 
                src={logo} 
                alt="Bwossy logo" 
                className={`login-logo ${isLogoPressed ? 'pressed' : ''}`}
              />*/}
              {/*<span className="login-logo-name">{t('common.appName')}</span>*/}
            </a>
          </div>

          {/* Homepage nav bar. 
          <div className="homepage-toolbar-container">
            <div className="homepage-toolbar-item">
              <span className="homepage-toolbar-text">Home</span>
            </div>
            <div className="homepage-toolbar-item">
              <span className="homepage-toolbar-text">Why buttons?</span>
            </div>
            <div className="homepage-toolbar-item">
              <span className="homepage-toolbar-text">Blog</span>
            </div>
          </div>*/}
      </div>

      <div className="content-container">
        <div className="marketing-info">
          <h2>{t('homepage.headline')}</h2>
          <p>{t('homepage.subheadline')}</p>
        </div>

        <div className="login-container prelogin-container">
          <h1>{t('common.loginLabel')}</h1>
          <form onSubmit={handleSubmit} className="login-form" noValidate>
          {submitError && (
                <div className="general-error-message">
                  <ErrorOutlineIcon className="feedback-icon" />
                  {submitError}
                </div>
              )}
          <div className="form-group">
              <TextField 
                type="email" 
                value={email} 
                label={t('common.emailLabel')}
                variant="outlined"
                onChange={(e) => {
                  setEmail(e.target.value);
                  setEmailError('');
                  setSubmitError('');
                }} 
                error={Boolean(emailError) || Boolean(submitError)}
                helperText={emailError}
                required 
                fullWidth
              />
            </div>
            <div className="form-group input-field">
              <TextField
                type={showPassword ? 'text' : 'password'}
                value={password} 
                label={t('common.passwordLabel')}
                variant="outlined" 
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError('');
                  setSubmitError('');
                }} 
                error={Boolean(passwordError) || Boolean(submitError)}
                helperText={passwordError}
                required
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" className="input-adornment">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{
                          borderRadius: '50%', // Make the button circular
                        }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <p className="forgotpassword-text">
              <Trans 
                i18nKey="common.forgotPasswordLink"
                components={{
                  1: (
                    <a 
                      href="#" 
                      onClick={(e) => {
                        e.preventDefault(); // Prevent default navigation
                        handleOpenForgotPasswordOverlay(); // Open the overlay
                      }}
                    >
                      Forgot password? text
                    </a>
                  ),
                }}
              />
            </p>
              <TurnstileWidget setTurnstileTokenStatus={setTurnstileTokenStatus} />
              <Button
                type="submit"
                variant="contained"
                disabled={loading || turnstileTokenStatus !== "solved"} 
              >
                {loading ? t('common.loggingInLabel') : t('common.loginLabel')}
                </Button>
              {/*
              <p className="login-text">
                <Trans i18nKey="homepage.register"
                  components={{
                    1: <a href="/register">Register now</a>,
                  }}
                />
              </p>*/}
          </form>
        </div>

       
    </div>
  

      <ForgotPassword
        isVisible={isForgotPasswordOverlayVisible}
        onClose={handleCloseForgotPasswordOverlay}
      />

      <Footer />
      
    </div>
  );
};

export default Homepage;
